import type SignalCreateDTO from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalCreateDTO";
import type SignalUpdateDTO from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalUpdateDTO";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";

import type Signal from "../core/Signal";
import type SignalFilters from "../core/SignalFilters";
import type SignalSource from "../core/SignalSource";
import SignalType from "../core/SignalType";
import type { SignalTemplateDeps } from "../templates/SignalTemplate";
import SignalTemplate from "../templates/SignalTemplate";

import type AdNetworkSignalFilters from "./AdNetworkSignalFilters";

type AdNetworkSignalTemplateDeps = Omit<SignalTemplateDeps<AdNetworkSignalFilters>, "signalType">;

export default class AdNetworkSignalTemplate extends SignalTemplate<AdNetworkSignalFilters> {
    constructor(deps: AdNetworkSignalTemplateDeps) {
        super({ ...deps, signalType: SignalType.AdNetwork });
    }

    isValid(): boolean {
        const isSubTypeDefined = typeof this.signalSubType !== "undefined";
        const isActionFilterDefined = typeof this.filters.action !== "undefined";

        return isSubTypeDefined && isActionFilterDefined;
    }

    matchesSignal(signal: Readonly<Signal<AdNetworkSignalFilters>>): boolean {
        return this.filters.action === signal.filters.action;
    }

    getSignalCreateDTO<F extends SignalFilters>(
        filters: Readonly<F>,
        signalSource: SignalSource,
    ): Readonly<SignalCreateDTO<F>> {
        return {
            isDefault: false,
            signalSource: signalSource,
            signalType: this.signalType,
            signalSubType: this.signalSubType,
            lifecycleStatus: this.lifecycleStatus,
            filters,
        };
    }

    getSignalUpdateDTO<F extends SignalFilters>(
        uiSignal: Readonly<UISignal<F>>,
        filters: Readonly<F>,
    ): Readonly<SignalUpdateDTO<F>> {
        const { id, isDefault } = uiSignal;
        return {
            id,
            isDefault,
            signalType: this.signalType,
            signalSubType: this.signalSubType,
            filters,
        };
    }
}
